import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import * as AdminModels from '../../../models/AdminModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { AdminUserSessionContext } from '../../../viewmodels/AdminViewModels';
import { invalidateAllIndustryAutomationTemplatesQueries } from './useIndustryAutomationTemplatesQuery';

interface IParams {
	templateId: string;
	name?: string;
}

export function useDuplicateIndustryAutomationTemplateMutation({
	onError,
	onSuccess,
}: {
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: (res: AdminModels.ISystemAutomationTemplate) => void;
} = {}) {
	const userSession = useUserSession<AdminUserSessionContext>();
	return useMutation({
		mutationFn: async ({ templateId, name }: IParams) => {
			const queryParam = name ? `?name=${encodeURIComponent(name)}` : '';
			const url = `admin/AutomationTemplate/${templateId}/clone${queryParam}`;

			const result = await userSession.webServiceHelper.callAsync<AdminModels.ISystemAutomationTemplate>(url, 'POST');

			return result;
		},
		onError,
		onSuccess: data => {
			invalidateAllIndustryAutomationTemplatesQueries();
			onSuccess?.(data);
		},
	});
}
